module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_9006.6ee7eb44.png";